// src/pages/products/Fundtz.jsx
import React from 'react';
import ProductTemplate from '../../components/products/ProductTemplate';
import fundtzHero from '../../assets/images/expertise.jpg';
import fundtzProduct from '../../assets/images/expertise.jpg';

const Fundtz = () => {
  const features = [
    { icon: '📋', title: 'Work Order Management', description: 'Create, assign, track, and manage work orders from creation to completion with real-time status updates' },
    { icon: '💰', title: 'Quotation Management', description: 'Generate professional quotations, send to clients, track approvals, and convert to invoices seamlessly' },
    { icon: '📄', title: 'Invoicing System', description: 'Create and send professional invoices, set recurring billing, and manage payment tracking' },
    { icon: '👥', title: 'Client Management', description: 'Centralized client database with contact information, payment history, and communication logs' },
    { icon: '🤖', title: 'Automated Payment Reminders', description: 'Schedule automatic payment reminders and follow-ups to reduce late payments' },
    { icon: '📊', title: 'Financial Dashboard', description: 'Real-time insights into revenue, outstanding payments, and business performance' },
    { icon: '💳', title: 'Multiple Payment Gateways', description: 'Accept payments via credit card, bank transfer, PayPal, Stripe, and more' },
    { icon: '📱', title: 'Mobile Friendly', description: 'Access and manage your finances on the go with responsive mobile design' },
    { icon: '🔗', title: 'Bank Integration', description: 'Seamless integration with major banks for automatic reconciliation' },
    { icon: '📎', title: 'Document Attachment', description: 'Attach files, receipts, and documents to work orders, quotes, and invoices' },
    { icon: '🔒', title: 'Secure Data Storage', description: 'Bank-grade encryption for all financial data and client information' },
    { icon: '📈', title: 'Expense Tracking', description: 'Track business expenses and categorize them for better financial management' },
    { icon: '📑', title: 'Multi-Currency Support', description: 'Handle transactions in multiple currencies for global business operations' },
    { icon: '🏷️', title: 'Custom Branding', description: 'Add your logo and brand colors to all invoices and quotations' },
    { icon: '📊', title: 'Tax Management', description: 'Automated tax calculations for multiple tax rates and jurisdictions' },
    { icon: '📧', title: 'Email Integration', description: 'Send invoices and quotes directly from your email client' },
    { icon: '📅', title: 'Recurring Billing', description: 'Set up subscription billing and recurring invoices for repeat customers' },
    { icon: '📋', title: 'Report Generation', description: 'Generate financial reports including profit & loss, tax summaries, and aging reports' }
  ];

  const benefits = [
    'Reduce payment collection time by up to 50% with automated reminders',
    'Eliminate manual data entry errors with automated workflows',
    'Improve cash flow visibility with real-time financial dashboards',
    'Save hours of administrative work each week',
    'Enhance professional image with branded invoices and quotes',
    'Track work orders from creation to invoice payment in one place',
    'Make data-driven decisions with comprehensive financial reporting',
    'Scale your business without adding administrative overhead'
  ];

  const industries = [
    'Construction', 'Manufacturing', 'Home Services', 'Freelancers',
    'Retail', 'Consulting', 'Agencies', 'Contractors',
    'Property Management', 'Healthcare', 'Education', 'Non-Profit'
  ];

  const specifications = [
    { label: 'Deployment', value: 'Cloud-based (SaaS)' },
    { label: 'Platform', value: 'Web, iOS, Android' },
    { label: 'Security', value: '256-bit SSL Encryption, GDPR Compliant' },
    { label: 'Integration', value: 'REST API, Zapier, Bank Feeds, Accounting Software' },
    { label: 'Support', value: 'Email, Chat, and Phone Support' },
    { label: 'Updates', value: 'Automatic monthly updates' },
    { label: 'Languages', value: '10+ languages supported' },
    { label: 'Payment Gateways', value: 'Stripe, PayPal, Square, Bank Transfer' },
    { label: 'Export Formats', value: 'PDF, CSV, Excel, QuickBooks' },
    { label: 'Data Backup', value: 'Automated daily backups' }
  ];

  const workflows = [
    { name: 'Quote to Cash', description: 'Create quote → Send to client → Get approval → Convert to invoice → Receive payment', icon: '💰' },
    { name: 'Work Order Management', description: 'Create work order → Assign technician → Track progress → Complete → Generate invoice', icon: '📋' },
    { name: 'Recurring Billing', description: 'Setup subscription → Auto-generate invoice → Send reminder → Process payment', icon: '🔄' },
    { name: 'Expense Tracking', description: 'Log expense → Categorize → Attach receipt → Track for reporting', icon: '📊' }
  ];

  return (
    <ProductTemplate
      title="Fundtz"
      badge="FINANCIAL SOFTWARE"
      tagline="Invoicing, Work Order & Quotation Software"
      description="Your all-in-one solution for managing invoicing, work orders, and quotations. Designed to simplify financial operations, Fundtz is a powerful tool for businesses looking to automate and optimize their financial workflows. Whether you're a small business owner, a freelancer, or part of a larger enterprise, Fundtz provides the efficiency and accuracy you need to stay on top of your financial tasks."
      heroImage={fundtzHero}
      productImage={fundtzProduct}
      features={features}
      benefits={benefits}
      industries={industries}
      specifications={specifications}
      ctaText="Start Free Trial"
      ctaLink="/contact"
    />
  );
};

export default Fundtz;